/**
 * Arithmetic opcode handlers (0x01-0x0b)
 */

export { exp } from "./0x0a_EXP.js";
export { signextend } from "./0x0b_SIGNEXTEND.js";
export { add } from "./0x01_ADD.js";
export { mul } from "./0x02_MUL.js";
export { sub } from "./0x03_SUB.js";
export { div } from "./0x04_DIV.js";
export { sdiv } from "./0x05_SDIV.js";
export { mod } from "./0x06_MOD.js";
export { smod } from "./0x07_SMOD.js";
export { addmod } from "./0x08_ADDMOD.js";
export { mulmod } from "./0x09_MULMOD.js";
